export const MARKET_CLOUD_ID = 1 // 营销云
export const SALE_CLOUD_ID = 2 // 销售云
